import AnamnesisView, { Views as ANAMNESIS_VIEWS } from 'components/organisms/Anamnesis';
import { calculateBmi } from 'helper/bmi';
import i18n from 'helper/i18n';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import {
	actionCreators,
	getIsUpdatingAnamnesis,
	getSuggestedWeightReduceGoal,
	getTempHealthGoal,
	getWeightReduceGoal,
	getWeightReduceMax,
	getWeightReduceMin,
} from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { WithRouterType } from 'types/withRouter';
import { mapParentStateToProps } from '../Anamnesis';
import { GOALS } from './AcceptHealthTarget';

export const mapStateToProps = (state: IRootState, props: WithRouterType) => {
	const parentProps = mapParentStateToProps(state, props);
	const bmiValue = calculateBmi(
		parentProps.weight === null ? undefined : parentProps.weight,
		parentProps.size === null ? undefined : parentProps.size,
		true,
		true
	);

	return {
		...parentProps,
		currentStep: ANAMNESIS_VIEWS.DEFINE_HEALTH_TARGET,
		isUpdatingAnamnesis: getIsUpdatingAnamnesis(state),
		introTitle: i18n('react.impulsCoach.components.anamnesis.defineHealthTarget.introTitle'),
		introText: i18n('react.impulsCoach.components.anamnesis.defineHealthTarget.introText'),
		title: i18n('react.impulsCoach.components.anamnesis.defineHealthTarget.title'),
		bmiValue,
		reduceWeightTarget: {
			recommendedReduceWeight: getSuggestedWeightReduceGoal(state),
			reduceGoal: getWeightReduceGoal(state),
			recommendedStart: getWeightReduceMin(state),
			recommendedEnd: getWeightReduceMax(state),
		},
		goals: GOALS,
		tempHealthGoal: getTempHealthGoal(state),
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export type DefineHealthTargetContainerProps = ReturnType<typeof mapStateToProps> &
	ReturnType<typeof mapDispatchToProps>;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnamnesisView) as any);
